var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("TABLE_HEADER_clientUserName"),
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: function ($event) {
          _vm.show = false
        },
      },
    },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: { clearable: "", filterable: "" },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        _vm._l(_vm.options, function (v, k) {
          return _c("el-option", {
            key: k,
            attrs: { label: `${v.userName} (${v.email})`, value: v.id },
          })
        }),
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "wl-green", on: { click: _vm.onConfirmHere } },
            [_vm._v(_vm._s(_vm.$t("btn_submit")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }